import type { CountryType } from "../@types/generic";

export const getDayjsLocale = (country: CountryType): Promise<ILocale> => {
    switch (country) {
        case "cs": // Czech
            return import("dayjs/locale/cs");
        case "da": // Danish
            return import("dayjs/locale/da");
        case "es": // Spanish
            return import("dayjs/locale/es");
        case "fr": // French
            return import("dayjs/locale/fr");
        case "it": // Italian
            return import("dayjs/locale/it");
        case "nl": // Dutch
            return import("dayjs/locale/nl");
        case "pl": // Polish
            return import("dayjs/locale/pl");
        case "ro": // Romanian
            return import("dayjs/locale/ro");
        case "sk": // Slovak
            return import("dayjs/locale/sk");
        case "sv": // Swedish
            return import("dayjs/locale/sv");
        case "uk": // English, UK
        case "us": // English, US
            return import("dayjs/locale/en");
        case "de": // German
        case "at":
        case "ch":
        default:
            return import("dayjs/locale/de");
    }
};
